import React, { useState } from "react";

import styled from "@emotion/styled";
import {
  createStyles,
  Indicator,
  Input,
  Select,
  TextInput,
} from "@mantine/core";
import { Box, Divider, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DatePicker } from "@mantine/dates";
import dayjs from "dayjs";
import ccString from "../../data/countriesString";
const titleLabels = [
  { value: "mr", label: "Mr." },
  { value: "ms", label: "Ms." },
  { value: "mrs", label: "Mrs." },
  { value: "miss", label: "Miss." },
  { value: "dr", label: "Dr." },
];
const genderLabels = [
  { value: "m", label: "Male" },
  { value: "f", label: "Female" },
  { value: "o", label: "Other" },
];
const milesLabels = [
  { value: "m", label: "Miles & More" },
  { value: "l", label: "Luthansa Prime" },
  { value: "o", label: "Other" },
];
const InputsBox = styled(Box)({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  // width: "100%",
});
const InputContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  margin: "5px 20px",
  gap: 1,
  flex: 1,
});
type Props = {
  currentPassenger: any;
  passengers: any;
  currentPassengerId: any;
  currentPassengerIdx: any;
  updatePassengers: (data: any) => void;
};
const useStyles = createStyles((theme) => ({
  root: {
    position: "relative",
  },

  input: {
    height: "54px",
    paddingTop: "18px",
  },

  label: {
    position: "absolute",
    pointerEvents: "none",
    fontSize: theme.fontSizes.xs,
    paddingLeft: theme.spacing.sm,
    paddingTop: `calc(${theme.spacing.sm} / 2)`,
    zIndex: 1,
  },
}));
const PassengerForm = ({
  currentPassenger,
  passengers,
  currentPassengerId,
  currentPassengerIdx,
  updatePassengers,
}: Props) => {
  const { classes } = useStyles();
  const [age, setAge] = useState<string>(currentPassenger.age);
  const [family_name, setFamilyName] = useState<string>(
    currentPassenger.family_name
  );
  const [given_name, setGivenName] = useState<string>(
    currentPassenger.given_name
  );
  const [gender, setGender] = useState<string>(currentPassenger.gender);
  const [born_on, setBornOn] = useState<Date | null>(currentPassenger.born_on);
  const [title, setTitle] = useState<string>(currentPassenger.title);

  // client contact
  const [phone_number, setPhoneNumber] = useState<string>(
    currentPassenger.phone_number
  );
  const [email, setEmail] = useState<string>(currentPassenger.email);
  const [isClient, setIsClient] = useState<boolean>(false);
  // passport details
  const [countryOfIssue, setCountryOfIssue] = useState<string>(
    currentPassenger.countryOfIssue
  );
  const [passportNumber, setPassportNumber] = useState<string>(
    currentPassenger.passportNumber
  );
  const [expirydate, setExpiryDate] = useState<Date | null>(
    currentPassenger.expirydate
  );
  const [miles, setMiles] = useState<string>(currentPassenger.miles);
  const [milesNumber, setMilesNumber] = useState<string>(
    currentPassenger.milesNumber
  );
  const setInputInformation = (inputName: any, inpValue: any) => {
    switch (inputName) {
      case "age":
        setAge(inpValue);
        break;
      case "family_name":
        setFamilyName(inpValue);
        break;
      case "given_name":
        setGivenName(inpValue);
        break;
      case "gender":
        setGender(inpValue);
        break;
      case "born_on":
        setBornOn(inpValue);
        break;
      case "title":
        setTitle(inpValue);
        break;
      case "miles":
        setMiles(inpValue);
        break;
      case "milesNumber":
        setMilesNumber(inpValue);
        break;
      case "phone_number":
        setPhoneNumber(inpValue);
        break;
      case "email":
        setEmail(inpValue);
        break;
      case "isClient":
        setIsClient(inpValue);
        break;
      case "countryOfIssue":
        setCountryOfIssue(inpValue);
        break;
      case "passportNumber":
        setPassportNumber(inpValue);
        break;
      case "expirydate":
        setExpiryDate(inpValue);
        break;
      default:
        break;
    }

    passengers[currentPassengerIdx][inputName] = inpValue;
    console.log("====================================");
    console.log("NEW PASSENGER: ", passengers);
    console.log("====================================");
    updatePassengers(passengers);
  };
  /*
  useEffect(() => {
    const ccString: string[] = [];

    countries.map((c: any) => {
      ccString.push(c.name.common);
    });
    console.log("====================================");
    console.log("COUNTRIES LIST: ", ccString.sort());
    console.log("====================================");
  }, []);
*/
  return (
    <>
      <InputsBox>
        <InputContainer>
          <Select
            mt="md"
            withinPortal
            data={titleLabels}
            placeholder="Choose"
            label="Title"
            classNames={classes}
            value={currentPassenger.title}
            onChange={(evt) => setInputInformation("title", evt)}
          />
        </InputContainer>
        <InputContainer>
          <TextInput
            label="Firstname"
            placeholder="ex: Simon"
            classNames={classes}
            value={currentPassenger.given_name}
            onChange={(evt) =>
              setInputInformation("given_name", evt.target.value)
            }
          />
        </InputContainer>
        <InputContainer>
          <TextInput
            label="Lastname"
            placeholder="ex: timplar"
            classNames={classes}
            value={currentPassenger.family_name}
            onChange={(evt: any) =>
              setInputInformation("family_name", evt.target.value)
            }
          />
        </InputContainer>
      </InputsBox>
      <InputsBox>
        <InputContainer>
          <Select
            mt="md"
            withinPortal
            data={genderLabels}
            placeholder="Choose"
            label="Gender"
            classNames={classes}
            value={currentPassenger.gender}
            onChange={(evt) => setInputInformation("gender", evt)}
          />
        </InputContainer>
        <InputContainer>
          <DatePicker
            placeholder="____/__/__"
            mt="md"
            label="Birth date"
            classNames={classes}
            clearable={false}
            value={born_on}
            onChange={(evt: any) => setInputInformation("born_on", evt)}
            inputFormat="DD/MM/YYYY"
          />
        </InputContainer>
        <InputContainer>
          <Select
            mt="md"
            withinPortal
            data={ccString}
            placeholder="Choose"
            label="Nationality"
            classNames={classes}
            value={countryOfIssue}
            onChange={(evt) => setInputInformation("countryOfIssue", evt)}
          />
        </InputContainer>
      </InputsBox>
      <Divider orientation="horizontal" component="hr" />
      <InputsBox>
        <InputContainer>
          <TextInput
            label="Passport number"
            placeholder="ex: 15AH780P"
            classNames={classes}
            value={passportNumber}
            onChange={(evt: any) =>
              setInputInformation("passportNumber", evt.target.value)
            }
          />
        </InputContainer>
        <InputContainer>
          <DatePicker
            placeholder="____/__/__"
            mt="md"
            label="Expiry date"
            classNames={classes}
            clearable={false}
            value={expirydate}
            onChange={(evt: any) => setInputInformation("expirydate", evt)}
            inputFormat="DD/MM/YYYY"
            minDate={dayjs(new Date()).add(0).toDate()}
          />
        </InputContainer>
      </InputsBox>
      <InputsBox>
        <InputContainer>
          <Select
            mt="md"
            withinPortal
            data={milesLabels}
            placeholder="Choose"
            label="Miles"
            classNames={classes}
            value={currentPassenger.miles}
            onChange={(evt) => setInputInformation("miles", evt)}
          />
        </InputContainer>
        <InputContainer>
          <TextInput
            label="Miles registration number"
            placeholder="ex: M1234..."
            classNames={classes}
            value={milesNumber}
            onChange={(evt) =>
              setInputInformation("milesNumber", evt.target.value)
            }
          />
        </InputContainer>
      </InputsBox>
      <InputsBox>
        <InputContainer>
          <TextInput
            label="Email"
            placeholder="ex: jk@teksatravel.com"
            classNames={classes}
            value={email}
            onChange={(evt: any) =>
              setInputInformation("email", evt.target.value)
            }
          />
        </InputContainer>
        <InputContainer>
          <TextInput
            label="Phone number"
            placeholder="ex: +32123456789"
            classNames={classes}
            value={phone_number}
            onChange={(evt) =>
              setInputInformation("phone_number", evt.target.value)
            }
          />
        </InputContainer>
      </InputsBox>
    </>
  );
};

export default PassengerForm;
